export default __webpack_public_path__ + "static/media/epigro_2.8bdd9f2a.png";